
import {Vue, Component, Prop} from 'vue-property-decorator';
import TeacherIcon from "src/modules/teacher/TeacherIcon.vue";

@Component({
  components: {TeacherIcon}
  })
export default class TeacherNotice extends Vue {
  @Prop({default: ''}) notice!: string;
  @Prop({default: 'horizontal'}) orientation!: 'horizontal' | 'vertical';
  @Prop({default: false}) dense!: boolean;
  @Prop({default: false}) closable!: boolean;
  @Prop({default: 'default'}) teacherSize!: string;
  @Prop({default: '#eeeeee'}) bgColor!: string;


  private isDisplayed = true;

  get actualTeacherSize() {
    if (this.teacherSize === "default") {
      return this.$q.screen.gt.sm ? '70px' : '50px';
    }
    else {
      return this.teacherSize
    }
  }

}
